import gsap from "gsap";
import EventDispatcher from "../../common/EventDispatcher";
import {
    Global
} from "../../common/global";

export default class Intro {
    constructor() {

        document.querySelector("#intro_scr #letsPlay").addEventListener("click", this.startGame.bind(this));

    }
    init() {

        this.events = EventDispatcher.getObj();
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));


    }
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "show_screen":
                this.showScreen(data['message']['data']);
                break;
            case "hide_screen":
                this.hideScreen(data['message']['data']);
                break;
        }
    }
    startGame() {
        this.introTwn && this.introTwn.kill();
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "enable_control",
                data: {}
            }
        });
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "start_time",
                data: {}
            }
        });
        document.querySelector("#intro_scr").classList.remove("active")

    }
    showAnimation() {
        this.frameDate = {
            'value': 1
        }
        this.lastVal = 0;
        this.introTwn = gsap.to(this.frameDate, {
            value: 83, // Animates from 10 to 0
            duration: 2, // 10 seconds
            ease: "none",
            repeat: -1,
            delay: 1,
            onUpdate: function () {
                if (this.lastVal != Math.floor(this.frameDate.value)) {
                    document.querySelector("#intro_scr .info2 .icon").classList.remove(`hand${this.lastVal}`);

                    this.lastVal = Math.floor(this.frameDate.value);
                    document.querySelector("#intro_scr .info2 .icon").classList.add(`hand${this.lastVal}`);

                }
            }.bind(this)
        });
    }
    showScreen(data) {
        if (data['screenKey'] !== "Intro") return false;

        Global.introShown = true;
        Global.introActive = true;
        document.querySelector("#intro_scr").classList.add("active")
        this.showAnimation();
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "disable_control",
                data: {}
            }
        });
        //
    }
    hideScreen(data) {
        if (data['screenKey'] !== "Intro") return false;

        Global.introActive = false;
        document.querySelector("#intro_scr").classList.remove("active");

        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "start_time",
                data: {}
            }
        });
    }
}